import { render } from "./ChangeOwnerComponent.vue?vue&type=template&id=43e2ad9e&scoped=true"
import script from "./ChangeOwnerComponent.vue?vue&type=script&lang=js"
export * from "./ChangeOwnerComponent.vue?vue&type=script&lang=js"

import "./ChangeOwnerComponent.vue?vue&type=style&index=0&id=43e2ad9e&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43e2ad9e"]])

export default __exports__